import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6ecb7c0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "bg",
  style: {"text-align":"center"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { id: "movie-list" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","flex-direction":"column","align-items":"center"} }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Movie Watch List"),
  /*#__PURE__*/_createElementVNode("p", { style: {"width":"80vw","text-align":"center"} }, " In this project, I created a method for my friends and family to add movies to a running, public list. This implements AWS Services such as API Gateway, Lambda, and DynamoDB. In order to limit attacks on traffic, there are checks in place to reject requests with unsuppored data, as well as a hard limit read/writes via the API key / day. ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"font-size":"40px","color":"#f9f9f9","text-align":"center"} }, " Add the movies you want to see in the form at the bottom. ", -1))
const _hoisted_5 = { style: {"padding-left":"5vw","padding-right":"5vw"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Movie List", -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"text-align":"left"} }, "Add a Movie", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "submit" }, "Add Movie", -1))

import { ref, computed } from "vue";
import { Movie, getMovies, postMovie } from "@/api/callMovies"; // Adjust the path as necessary


import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "MovieList",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const movies = ref<Movie[]>([]);
const movie = ref({
  movie_id: "",
  title: "",
  genre: "",
  release_year: "",
});

const format = (data: { S: string }): string => {
  return data.S;
};

const addMovie = async () => {
  try {
    await postMovie(movie.value);
    movie.value = { movie_id: "", title: "", genre: "", release_year: "" }; // Reset form
    await fetchMovies(); // Refresh the movie list
  } catch (error) {
    console.error("Error adding movie:", error);
  }
};

const fetchMovies = async () => {
  try {
    movies.value = await getMovies(); // Call the imported function
  } catch (error) {
    console.error("Error fetching movies:", error);
  }
};
fetchMovies();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      (movies.value.length)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(movies.value, (movie) => {
              return (_openBlock(), _createElementBlock("li", {
                key: movie.movie_id
              }, [
                _createElementVNode("b", null, _toDisplayString(format(movie.movie_id)), 1),
                _createTextVNode(" (" + _toDisplayString(format(movie.release_year)) + ") ", 1)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_8, "No movies found.")),
      _hoisted_9,
      _createElementVNode("form", {
        onSubmit: _withModifiers(addMovie, ["prevent"])
      }, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((movie.value.movie_id) = $event)),
          placeholder: "Title",
          required: ""
        }, null, 512), [
          [_vModelText, movie.value.movie_id]
        ]),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((movie.value.release_year) = $event)),
          placeholder: "Release Year",
          required: ""
        }, null, 512), [
          [_vModelText, movie.value.release_year]
        ]),
        _hoisted_10
      ], 32)
    ])
  ]))
}
}

})